import { IAction } from '../../interface/action/action.interface';
import { ActionEnum } from '../../enum/action.enum';

export function getActionName(action: IAction) {
  if (!action) {
    return '';
  }
  return (action.isImmediate ? '[immediate]' : '') + `[${ActionEnum[ action.type ]}]`;
}
